//1.导入VueRouter
import Vue from "vue";
import VueRouter from 'vue-router'
import {
  readStoredCanViewStatistics,
  readStoredHasCaseRole,
  readStoredRenderAccess,
  readStoredCanManageProducts,
  readStoredCanEnterManagementPage,
  readStoredProjectsHomePath,
  readStoredCanViewIkkodateEvaluations,
  readStoredCanUseSai,
} from '@/utils/userPermissionStorage'
import { saveTermsPendingRedirect, shouldRequireTermsAgreement } from '@/utils/termsAgreementStorage'
import {
  enterArchitecturePlanConstraints,
  enterArchitecturePlanEditor,
  enterArchitecturePlanProduct
} from '@/ikkodate/utils/floorplanInputRouteGuards'
//2.使用路由
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}
//3.创建VueRouter的实例
const router = new VueRouter({
  //tips:不想要 #（锚点）就添加下面代码
  mode:'history',
  // 通常は '/'。プレビュー（サブパス配信）では publicPath に合わせる
  base: process.env.BASE_URL,
  //4.配置路由的path和组件
  routes: [
    {
      path: "/",
      redirect: to => ({ path: '/login', query: to.query })
    },
    {
      path: "/login",
      name: 'login',
      component: () => import('../views/account/LoginView.vue')
    },
    {
      path: "/register",
      name: 'register',
      component: () => import('../views/account/LoginView.vue')
    },
    {
      path: "/docs",
      name: "Docs",
      component: () => import('../views/docs/DocumentationView.vue')
    },
    {
      path: "/projects",
      component: () => import('../views/layout/ProjectShellView.vue'),
      redirect: () => readStoredProjectsHomePath(),
      children: [
        {
          path: "render",
          component: () => import('../views/airender/RenderProject.vue')
        },
        {
          path: "ikkodate",
          name: 'projects-ikkodate',
          component: () => import('../ikkodate/views/plan/IkkodateProjectView.vue')
        },
        {
          path: "ikkodate-evaluation",
          name: 'ikkodate-evaluation',
          component: () => import('../ikkodate/views/evaluation/IkkodateEvaluationView.vue')
        },
        {
          path: "cases/create",
          component: () => import('../views/casecenter/CaseCreate.vue')
        },
        {
          // プラットフォーム管理者が依頼情報を直す（?key=案件の idempotencyKey）。画面は案件作成と同じ
          path: "cases/request-edit",
          component: () => import('../views/casecenter/CaseCreate.vue')
        },
        {
          path: "cases",
          component: () => import('../views/casecenter/CaseProject.vue')
        },
        {
          path: "case-statistics",
          component: () => import('../views/casecenter/CaseStatistics.vue')
        },
        {
          path: "freebox",
          component: () => import('../views/casecenter/CaseCatalogView.vue')
        },
        {
          path: "case-management",
          component: () => import('../views/casecenter/CaseManagement.vue')
        },
        {
          // S-AI（工務店向け AI 受注支援）のホーム：AI に依頼して成果物（カルテ・概算積算など）を作る
          path: "s-ai",
          name: 'projects-s-ai-home',
          component: () => import('../views/sai/SaiHomeView.vue')
        },
        {
          // 6 モジュール（集客・営業・設計・積算・工事・経営）の画面。ホームの成果物もここで開ける
          path: "s-ai/:module",
          name: 'projects-s-ai',
          component: () => import('../views/sai/SaiModuleView.vue')
        },
      ]
    },
    {
      path: '/projects/ikkodate/constraints',
      name: 'ikkodate_architecture_plan_constraints',
      component: () => import('../ikkodate/views/plan/floorplan-input-wizard/WizardConstraintsView.vue'),
      beforeEnter: enterArchitecturePlanConstraints
    },
    {
      path: '/projects/ikkodate/product',
      name: 'ikkodate_architecture_plan_product',
      component: () => import('../ikkodate/views/plan/floorplan-input-wizard/WizardProductView.vue'),
      beforeEnter: enterArchitecturePlanProduct
    },
    {
      path: '/projects/ikkodate/editor',
      name: 'ikkodate_architecture_plan_editor',
      component: () => import('../ikkodate/views/plan/IkkodateEditorView.vue'),
      beforeEnter: enterArchitecturePlanEditor
    },
    {
      path: "/setting",
      component: () => import('../views/account/PasswordResetView.vue')
    },
    {
      path: "/wallets",
      name: 'wallet',
      component: () => import('../views/mypage/MyPageView.vue')
    },
    {
      path: "/wallets/recharge",
      name: 'wallet-recharge',
      component: () => import('../views/mypage/MyPageRechargeView.vue')
    },
    {
      path: "/admin",
      component: () => import('../views/admin/AdministratorsData.vue'),
      redirect:"/admin/data",
      children: [
        {
          path: "data",
          component: () => import('../views/admin/AdminProjectOverview.vue'),
          name:'建筑图像渲染项目数据分析'
        },
        {
          path: "user",
          component: () => import('../views/admin/AdminUser.vue'),
          name:'用户列表'
        },
        {
          path: "allProjectList",
          component: () => import('../views/admin/AdminData.vue'),
          name:'建筑图像渲染项目'
        },
        {
          path: "userFeedback",
          component: () => import('../views/admin/AdminUserFeedback.vue'),
          name: '用户反馈'
        },
        {
          path: "campaignCode",
          component: () => import('../views/admin/AdminCampaignCode.vue'),
          name: '活动代码管理'
        },
        {
          path: "video",
          component: () => import('../views/admin/AdminVideo.vue'),
          name: '视频管理'
        }
      ]
    },
    {
      path: '/render-form', // 单个项目渲染设计页路径，带项目ID参数
      name: 'RenderDesign',
      component: () => import('../views/airender/RenderDesign.vue'),
      props: true,
    },
    {
      path: '/render-interior-form', // 内饰设计页路径（与立面共用同一套 UI，按模式切换）
      name: 'RenderInteriorDesign',
      component: () => import('../views/airender/RenderDesign.vue'),
      props: (route) => ({ ...route.params, designMode: 'interior' }),
    },
    {
      path: '/render-drawing-vectorize-form',
      name: 'RenderDrawingVectorizeForm',
      component: () => import('../views/airender/RenderDrawingVectorizeFormView.vue'),
    },
    {
      path: '/case-form',
      name: 'CaseForm',
      component: () => import('../views/casecenter/CaseForm.vue'),
    }

  ]
})

// 若某个懒加载 chunk 拉取失败（常见于网络异常/热更新失效），主动刷新页面以重新获取最新资源
const chunkLoadErrorPattern = /ChunkLoadError|Loading chunk [\w-]+ failed/i
router.onError((error) => {
  const message = error?.message || ''
  if (chunkLoadErrorPattern.test(message)) {
    // vue-router v3 的类型定义里没有暴露 history.pending，避免 TS 报错，这里只记录当前路由即可
    const targetPath = router.currentRoute && router.currentRoute.fullPath
    console.warn('[vue-router] chunk load failed, refreshing page', targetPath)
    window.location.reload()
  }
})

/**
 * 権限（available_item / userType）は前回ログインしたときに localStorage へ書いたもの。管理者が権限を変えた・
 * サブスクが切れた・形式が変わったのに再ログインしていないと、古い権限のまま行き先を決めてしまう。
 * 以前は /projects の画面（ProjectShellView・サイドバー）でしか読み直さず、古い権限で「権限なし」と判定されると
 * 全部 my page へ戻されてそこへ辿り着けない → 永久に my page から出られなかった（BS加盟店の報告、2026-09-30）。
 * ページを開いて最初の遷移の前に 1 回だけサーバーの最新を読む（読めなければ手元の権限のまま）。
 */
let storedPermissionsRefreshed = false
async function refreshStoredPermissionsOnce() {
  if (storedPermissionsRefreshed) return
  storedPermissionsRefreshed = true
  try {
    // 動的 import：api → httpClient → router の循環を読み込み時に作らない
    const { refreshStoredPermissions } = await import('@/utils/userPermissionRefreshState')
    await refreshStoredPermissions(0)
  } catch (e) {
    /* 読めなければ手元の権限で進む */
  }
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) { //拦截后设置标题
    document.title = to.meta.title
  }

  const isPublicRoute = to.matched.some(record => record.path === '/login' || record.path === '/register')
  const hasToken = !!localStorage.getItem('token')
  const isLoggedIn = hasToken || sessionStorage.getItem('loginStatus') === 'true'

  if (!isLoggedIn && !isPublicRoute) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  if (isLoggedIn && hasToken && !isPublicRoute) await refreshStoredPermissionsOnce()

  if (isLoggedIn && shouldRequireTermsAgreement()) {
    const termsGatePath = readStoredProjectsHomePath()
    if (!isPublicRoute && to.path !== termsGatePath) {
      saveTermsPendingRedirect(to.fullPath)
      next({ path: termsGatePath, replace: true })
      return
    }
  }

  // 按新权限模型（available_item）限制 /projects 子路由，与侧栏展示一致
  if (isLoggedIn && to.path.startsWith('/projects/')) {
    const hasCaseRole = readStoredHasCaseRole()
    const hasRender = readStoredRenderAccess()
    // 管理页：案件管理者 / 商品管理 / 渲染管理 のいずれか（権限編集の入口をここに一本化したため渲染管理者も入れる）
    const canManageAccountArea = readStoredCanEnterManagementPage() || readStoredCanManageProducts()
    // 可达首页：优先渲染，其次案件
    const home = readStoredProjectsHomePath()
    const p = to.path

    if (p.startsWith('/projects/s-ai')) {
      // S-AI は MH社員以上
      if (!readStoredCanUseSai()) {
        next({ path: home, replace: true })
        return
      }
    } else if (p.startsWith('/projects/ikkodate-evaluation')) {
      if (!readStoredCanViewIkkodateEvaluations()) {
        next({ path: home, replace: true })
        return
      }
    } else if (p.startsWith('/projects/render')) {
      if (!hasRender) {
        // 新規ユーザー（権限なし）はサブスクリプション開始ページへ
        next({ path: hasCaseRole ? '/projects/cases' : '/wallets', replace: true })
        return
      }
    } else if (p.startsWith('/projects/case-management')) {
      if (!canManageAccountArea) {
        next({ path: home, replace: true })
        return
      }
    } else if (p.startsWith('/projects/case-statistics')) {
      if (!readStoredCanViewStatistics()) {
        next({ path: home, replace: true })
        return
      }
    } else if (p.startsWith('/projects/freebox')) {
      if (!hasCaseRole) {
        next({ path: home, replace: true })
        return
      }
    } else if (p.startsWith('/projects/cases')) {
      if (!hasCaseRole) {
        next({ path: home, replace: true })
        return
      }
    }
  }

  next()
})
//5.导入路由实例
export default router
